<template>
  <fts-client-modal
    width="672px"
    title="Embed form"
    append-content-class="embed-form-modal__body"
    class="fts-embed-form-modal"
    ref="ftsEmbedFormModal"
    @closed="reset"
  >
    <!-- header:icon -->
    <font-awesome-icon slot="icon" :icon="['fas', 'code']" fixed-width />
    <!-- body -->
    <template #body>
      <div class="embed-clipboard-wrapper">
        <fts-spinner show :size="20" v-if="clipboardLoading" />
        <span
          title="Click to copy link"
          v-clipboard:copy="clipboardContent"
          v-clipboard:success="clipboardOnCopy"
          v-clipboard:error="clipboardOnError"
          v-else-if="clipboardContent"
        >
          {{clipboardContent}}
        </span>
        <div class="embed-clipboard-error" v-else>
          <div class="embed-clipboard-error-label">Error</div>
          <div class="embed-clipboard-error-description" v-if="clipboardError">{{clipboardError}}</div>
        </div>
      </div>
      <!-- preview -->
      <!-- Content Security Policy directive: "frame-ancestors 'self' -->
      <!-- <div v-html="clipboardContent" v-if="clipboardContent" /> -->
      <!-- hint -->
      <div class="embed-clipboard-hint" v-if="clipboardCopied">
        Copy to clipboard.
      </div>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn
        text
        :disabled="loading"
        @click="close"
      >
        <font-awesome-icon :icon="['fas', 'times']" /> Close
      </fts-btn>

      <fts-btn
        color="primary"
        :disabled="!clipboardContent"
        v-clipboard:copy="clipboardContent"
        v-clipboard:success="clipboardOnCopy"
        v-clipboard:error="clipboardOnError"
      >
        <font-awesome-icon :icon="['far', 'clone']" /> Copy
      </fts-btn> 

    </template>
  </fts-client-modal>
</template>

<script>
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

import { classificationStore } from '../store/classificationStore';

import FTSClientModal from "./FTSClientModal";
import FTSBtn from "./FTSBtn";
import FTSSpinner from "./FTSSpinner";

export default {
  components: {
    "fts-client-modal": FTSClientModal,
    "fts-btn": FTSBtn,
    "fts-spinner": FTSSpinner,
  },
  data: () => ({
    formData: null,
    loading: false,
    clipboardContent: null,
    clipboardTimeout: null,
    clipboardCopied: false,
    clipboardLoading: false,
    clipboardError: null,
  }),
  methods: {
    show(item) {
      this.formData = _.cloneDeep(item);
      this.$refs.ftsEmbedFormModal.show();
      this.generateClipboardContent();
    },
    close() {
      this.$refs.ftsEmbedFormModal.close();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    clipboardOnCopy() {
      const resetTimeout = () => {
        clearTimeout(this.clipboardTimeout);
        this.clipboardTimeout = null;
      }
      this.clipboardTimeout && resetTimeout();
      this.clipboardCopied = true;
      this.clipboardTimeout = setTimeout(() => {
        this.clipboardCopied = false;
        resetTimeout();
      }, 2000);
    },
    clipboardOnError() {
      console.error("ClipboardOnError");
    },
    async generateClipboardContent() {
      this.clipboardLoading = true;
      this.clipboardError = null;
      try {
        const res = await classificationStore.dispatch('shareForm', {
          moduleId: this.formData.moduleId,
          activityId: this.formData.activityId,
          ids: this.formData.id? [this.formData.id] : null,
          share: true
        });
        const link = res.data;
        if (link)
          this.clipboardContent = `<iframe width="640" height="768" src="${link}" title="Inistate share form" frameborder="0"></iframe>`;
        else
          throw 'error';
      } catch(err) {
        console.error(err);
        if (err.response && err.response.data && err.response.data.message) {
          this.clipboardError = err.response.data.message;
        } else {
          this.clipboardError = "Something went wrong.";
        }
      } finally {
        this.clipboardLoading = false;
      }
    },
  },
}
</script>

<style lang="scss">
.fts-embed-form-modal {
  .embed-form-modal__body {
    position: relative;
  }
  .embed-clipboard-wrapper {
    padding: .75rem;
    border-radius: .375rem;
    background-color: var(--fts-gray-100);
    span {
      word-break: break-all;
      font-size: .875rem;
      line-height: 1.25rem;
      cursor: pointer;
    }
  }
  .embed-clipboard-hint {
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    display: inline-flex;
    padding: 0.5rem;
    box-shadow: var(--fts-elevation-3);
    border-radius: 0.375rem;
    background-color: var(--fts-popover-background);
    color: var(--fts-light);
    font-size: 0.75rem;
  }
  .embed-clipboard-error {
    text-align: center;
    .embed-clipboard-error-label {
      font-weight: 500;
      font-size: 1.25rem;
      line-height: 1.75rem;
      color: var(--fts-danger);
    }
    .embed-clipboard-error-description {
      margin-top: .5rem;
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: var(--fts-default);
    }
  }
}
</style>